/**
 * Views and playback time tracker.
 */

import { metrics } from "utils/metrics";

class PlaybackTracker {
  private gifId: string|null = null;
  private startedAt: number|null = null;

  public constructor() {
    this.gifId = null;
    this.startedAt = null;
  }

  public stop(): void {
    if (this.gifId !== null && this.startedAt !== null) {
      const duration = Date.now() - this.startedAt;
      this.sendPlayback(this.gifId, duration);
    }

    this.gifId = null;
    this.startedAt = null;
  }

  public start(gif: string): void {
    this.stop();

    this.gifId = gif;
    this.startedAt = Date.now();

    this.sendView(gif);
  }

  private sendView(gif: string): void {
    console.debug(`[playback] gif ${gif} view.`);
  }

  private sendPlayback(gif: string, duration: number): void {
    console.debug(`[playback] gif ${gif} playback, ${duration} ms.`);
    metrics.sendGifPlayback({ gif, duration });
  }
}

export const playbackTracker = new PlaybackTracker();
